export enum EDeviceModel {
    UR042 = 2, // 001UR042 -- GW
    RGSM001 = 9,// RGSM001 -- GW
    RSLV001 = 10, // RSLV001 -- SUB_GW
    RETH001 = 11, // RETH001 -- GW
    RGSM001S = 12, // GSM standalone -- GW
    GW4G_RADIO = 14, // GW4G_RADIO -- GW
    QBE_DONT_AUTOMATION = 15,  // QBE_DONT_AUTOMATION -- GW
    QBE_MATTER = 16,
    GW4G_STANDALONE = 17, // GW4G_STANDALONE -- GW
    QBE_AUTOMATION = 18,//QBEMFSB2 -- GW
    SLAVE = 22, // SLAVE -- SUB_GW
    CAMEKWY_GW = 23, //CAMEKWY_GW  -- GW
    Input = 24,
    Output = 25,
    MultiIO = 26,
    MTMACONNECT = 27, //MTMACONNECT  -- GW
    MTMACONNECT_US = 40, //MTMACONNECT_US  -- GW
    IORS485 = 57,
    GEN_IORS485 = 977,
    RBE4 = 58,
    RBE4030 = 270,
    RBE4230 = 425,
    GEN_RBE4 = 978,
    RBE24230 = 131,
    RBE24 = 314,
    RBE230 = 241,
    GEN_RBE24230 = 972,
    ZLX24M = 993,
    ZLX24S = 994,
    ZBB3 = 974,
    ZBB3_BKX08AGF = 289,
    ZLB24S = 979,
    FROGX113 = 113,
    FROGX284 = 284,
    FROGX396 = 396,
}

export const GATEWAY_MODEL_LIST: number[] = [
    EDeviceModel.UR042,
    EDeviceModel.RGSM001,
    EDeviceModel.RETH001,
    EDeviceModel.RGSM001S,
    EDeviceModel.GW4G_RADIO,
    EDeviceModel.QBE_DONT_AUTOMATION,
    EDeviceModel.GW4G_STANDALONE,
    EDeviceModel.QBE_AUTOMATION,
    EDeviceModel.CAMEKWY_GW,
    EDeviceModel.MTMACONNECT,
    EDeviceModel.MTMACONNECT_US,
];

export const SUB_GATEWAY_MODEL_LIST: number[] = [
    EDeviceModel.RSLV001,
    EDeviceModel.SLAVE,
];

export enum EBoard {
    BOARD_ALIAS_ZBKE = 'ZBKE',
    BOARD_ALIAS_ZBKN = 'ZBKN',
    BOARD_ALIAS_ZN7 = 'ZN7',
    BOARD_ALIAS_ZN7V = 'ZN7V',
    BOARD_ALIAS_ZBX7N = 'ZBX7N',
    BOARD_ALIAS_ZLJ24 = 'ZLJ24',
    BOARD_ALIAS_ZM3 = 'ZM3',
    BOARD_ALIAS_ZL65 = 'ZL65',
    BOARD_ALIAS_ZL57 = 'ZL57',
    BOARD_ALIAS_ZL39 = 'ZL39',
    BOARD_ALIAS_ZL39EX = 'ZL39EX',
    BOARD_ALIAS_TOR200 = 'TOR200',
    BOARD_ALIAS_TOR300 = 'TOR300',
    BOARD_ALIAS_TOR400 = 'TOR400',
    BOARD_ALIAS_TOR500 = 'TOR500',
    BOARD_ALIAS_ZVL2 = 'ZVL2',
    BOARD_ALIAS_IORS485 = 'IORS485',
    BOARD_ALIAS_RBE4 = 'RBE4',
    BOARD_ALIAS_ZLX24S = 'ZLX24S',
    BOARD_ALIAS_ZBB3 = 'ZBB3',
    BOARD_ALIAS_ZLB24S = 'ZLB24S',
    BOARD_ALIAS_ZN8 = 'ZN8'
}

export enum ExcludeModelBoardType {
    MTMA_CONNECT = 27,
}

export enum ExcludeModelHwVersion {
    MTMA_CONNECT = 27,
}

export enum ExcludeModelFwVersion {
    MTMA_CONNECT = 27,
}


export enum EDeviceThermoModel {
    TH500 = 7,
    TH550 = 7,
    TH700 = 20,
    TH700WALL = 8,
    TH750WALL = 8,
    TH800 = 8,
    THONE = 13,
    THONEGW = 44,
    THONEBT = 45,
}

export enum EDeviceMtmaModel {
    MODULETYPE_MTMAC = 0, // 0 main
    MODULETYPE_MTM8C = 1, // 1 buttons
    MODULETYPE_MTMKB = 4, // 4 keypad
    MODULETYPE_MTMRFID = 5, // 5 rfid
    MODULETYPE_MTMDY = 6, // 6 display
    MODULETYPE_MTMINFO = 7, // 7 info
    // MODULETYPE_MTMNA     = 8 // 8 kpad controllo accessi (no mtma/connect)
    MODULETYPE_MTMBFVS = 9, // 9 hearing impaired (audiolesi)
    MODULETYPE_END = 10,
}

export const isMultiIo = (modelId: number): boolean => {
    if (modelId === EDeviceModel.MultiIO) {
        return true;
    }
    return false;
};

export const isMtmacModel = (modelId: number): boolean => {
    if (modelId === EDeviceModel.MTMACONNECT) {
        return true;
    }
    if (modelId === EDeviceModel.MTMACONNECT_US) {
        return true;
    }
    return false;
};

export const isMtmacStandardModel = (modelId: number): boolean => {
    if (modelId === EDeviceModel.MTMACONNECT) {
        return true;
    }
    return false;
};

export const isMtmacUsModel = (modelId: number): boolean => {
    if (modelId === EDeviceModel.MTMACONNECT_US) {
        return true;
    }
    return false;
};

export const isRbe4 = (modelId: number): boolean => {
    if (modelId === EDeviceModel.RBE4) {
        return true;
    }
    if (modelId === EDeviceModel.RBE4030) {
        return true;
    }
    if (modelId === EDeviceModel.RBE4230) {
        return true;
    }
    if (modelId === EDeviceModel.GEN_RBE4) {
        return true;
    }
    return false;
};

export const isZlx24 = (modelId: number): boolean => {
    if (modelId === EDeviceModel.ZLX24M) {
        return true;
    }
    if (modelId === EDeviceModel.ZLX24S) {
        return true;
    }
    return false;
};

export const isZbb3 = (modelId: number): boolean => {
    if (modelId === EDeviceModel.ZBB3) {
        return true;
    }
    if (modelId === EDeviceModel.ZBB3_BKX08AGF) {
        return true;
    }
    return false;
};

export const isZlb24 = (modelId: number): boolean => {
    if (modelId === EDeviceModel.ZLB24S) {
        return true;
    }
    if (modelId === EDeviceModel.FROGX113) {
        return true;
    }
    if (modelId === EDeviceModel.FROGX284) {
        return true;
    }
    if (modelId === EDeviceModel.FROGX396) {
        return true;
    }
    return false;
};


export const isZlx24sBoardName = (boardName: string): boolean => {
    if (boardName === EBoard.BOARD_ALIAS_ZLX24S) {
        return true;
    }
    return false;
};

export const isZbb3BoardName = (boardName: string): boolean => {
    if (boardName === EBoard.BOARD_ALIAS_ZBB3) {
        return true;
    }
    return false;
};

export const isZlb24sBoardName = (boardName: string): boolean => {
    if (boardName === EBoard.BOARD_ALIAS_ZLB24S) {
        return true;
    }
    return false;
};

export const isRbe4BoardName = (boardName: string): boolean => {
    if (boardName === EBoard.BOARD_ALIAS_RBE4) {
        return true;
    }
    return false;
};

export const isZn8BoardName = (boardName: string): boolean => {
    if (boardName === EBoard.BOARD_ALIAS_ZN8) {
        return true;
    }
    return false;
};


export const isThOneGw = (modelId: number): boolean => {
    if (modelId === EDeviceThermoModel.THONEGW) {
        return true;
    }
    return false;
};

export const isThOneBt = (modelId: number): boolean => {
    if (modelId === EDeviceThermoModel.THONEBT) {
        return true;
    }
    return false;
};

export const isModelGateway = (modelId: number): boolean => {
    if (GATEWAY_MODEL_LIST.includes((modelId))) {
        return true;
    }
    return false;
};

export const isModelSubGateway = (modelId: number): boolean => {
    if (SUB_GATEWAY_MODEL_LIST.includes((modelId))) {
        return true;
    }
    return false;
};